import { gql } from '@apollo/client';

export const FILTERED_REASON_FOR_TERMINATIONS = gql`
  query filteredReasonForTerminations($input: FilterReasonForTermination!) {
    filteredReasonForTerminations(input: $input) {
      id
      name
    }
  }
`;
